var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"button-demo"}},[_c('button-group-basic'),_c('button-group-toolbar'),_c('button-group-size'),_c('button-group-vertical')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }